import { Component } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

// Deploy troca os arquivos em /static/: o bundle já carregado na aba referencia
// hash de chunk que deixou de existir no servidor assim que alguém publica de
// novo. Ao navegar para uma tela ainda não carregada nesta sessão, o import()
// dinâmico do React.lazy falha — e essa rejeição não é algo que o Suspense
// consiga tratar sozinho. Sem este boundary, o erro sobe até o React desmontar
// a árvore inteira e a tela fica em branco.
const ehErroDeChunk = (erro) =>
    /loading chunk|dynamically imported module|chunkloaderror/i.test(`${erro?.name || ''} ${erro?.message || ''}`);

// A key={pathname} em App.js remonta este boundary a cada navegação, o que já
// limpa o estado de erro sozinho — não precisa de lógica extra para "tentar de
// novo" ao trocar de rota.
class ErrorBoundary extends Component {
    state = { erro: null };

    static getDerivedStateFromError(erro) {
        return { erro };
    }

    componentDidCatch(erro) {
        if (!ehErroDeChunk(erro)) return;
        // Reload único: evita loop se o servidor realmente estiver fora do ar.
        const chave = 'mpg-patio:recarregado-apos-chunk-invalido';
        if (sessionStorage.getItem(chave)) return;
        sessionStorage.setItem(chave, '1');
        window.location.reload();
    }

    render() {
        const { erro } = this.state;
        if (!erro) return this.props.children;

        if (ehErroDeChunk(erro)) {
            return (
                <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh">
                    <Stack spacing={2} alignItems="center">
                        <Typography color="text.secondary">Atualizando para a nova versão...</Typography>
                        <Button size="small" onClick={() => window.location.reload()}>Não atualizou? Clique aqui</Button>
                    </Stack>
                </Box>
            );
        }

        return (
            <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh" p={3}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Typography variant="h6">Não foi possível exibir esta tela</Typography>
                    <Typography color="text.secondary" maxWidth={420}>
                        Recarregue a página. Se o problema continuar, avise o suporte.
                    </Typography>
                    <Button variant="contained" onClick={() => window.location.reload()}>Recarregar página</Button>
                </Stack>
            </Box>
        );
    }
}

export default ErrorBoundary;
